<mat-form-field floatLabel="always" appearance=""
                [class.form-slim]="slim"
                class="mat-form-field-datepicker">
    <mat-label *ngIf="label">{{ label }}</mat-label>
    <input type="hidden"
           [(ngModel)]="calendarValue"
           (dateChange)="fromCalendar($event)"
           [matDatepicker]="picker"
           [max]="maxDate"
           [min]="minDate">

    <mat-label>{{ placeholder }}</mat-label>
    <input [imask]="mask"
           (blur)="fromInput($event)"
           (change)="fromInput($event)"
           [disabled]="disabled"
           [errorStateMatcher]="errorStateMatcher"
           [(ngModel)]="value"
           [placeholder]="placeholder"
           [required]="required"
           matInput>
    <mat-error *ngFor="let error of errorStateMatcher?.errors">
        {{ error.description ? error.description : error.code }}
    </mat-error>
    <mat-datepicker-toggle [disabled]="disabled" [for]="picker" matSuffix></mat-datepicker-toggle>
    <mat-datepicker #picker
                    [startAt]="startAt"
                    [startView]="startView">
    </mat-datepicker>
</mat-form-field>
